import React from 'react';
import style from './IconList.module.css';

function IconList({ list }) {
  return (
    <ul className={style.iconList}>
      {list.map((item, index) => (
        <li key={index} className={style.listItem}>
          <img src={item.media.src} alt="" className={style.icon} />
          <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
        </li>
      ))}
    </ul>
  );
}

export default IconList;